
<template>
  <div style="font-family: 'Roboto Slab', serif">
    <div v-if="Request == null || Request == '' || Request == undefined">
      <center class="loading-medium">
        <loading></loading>
      </center>
    </div>
    <div
      v-if="Request"
      style="
        width: 800px;
        height: 1100px;
        border: 1px solid black;
        margin: auto;
        padding: 20px;
        font-size: 14px;
      "
    >
      <div style>
        <div class="col-xs-3">
          <!-- <img
            src="../../assets/imgs/png/FAJRLOGO01.png"
            style="float: left; height: 90px; width: 130px"
          /> -->
        </div>
        <div class="col-xs-6">
          <h3
            style="
              font-weight: 500;
              margin-top: 60px;
              font-size: 28px;
              font-family: 'Roboto Slab', serif;
            "
          >
            DELIVERY INSTRUCTIONS
          </h3>
        </div>
        <div class="col-xs-3">
          <img
            :src="BankLogo"
            style="float: right; height: 44px; width: 195px"
          />
        </div>
      </div>
      <br clear="all" />
      <!-- <h2
      style="text-align:center;padding-bottom:0;border-top:solid 1px #000;margin-bottom:2px;padding-bottom:5px;padding-top:5px;border-bottom:solid 1px #000;"
      >SELLER'S OFFER</h2>-->

      <!-- <div style="padding-top:0;margin-top:0;height:1px;border-top:solid 1px #000;margin-top:1px"></div> -->
      <hr style="border: 1.2px solid #b35900" />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">From:</div>
          <div class="col-xs-10">
            {{ Request.BankName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">Reference:</div>
          <div class="col-xs-10">
            {{ Request.RefNo }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">To:</div>
          <div class="col-xs-10">Fajr Investment Advisory B.S.C. (c)</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">Date:</div>
          <div class="col-xs-10">
            {{ DateFromat(Request.ApplicationDate, true) }}
          </div>
        </div>
      </div>
      <hr style="border: 1px solid #b35900; margin-top: 5px" />

      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            Dear Sirs,
            <br />
            <br />
            We refer to our sale ( the
            <b>"Spot Sale Transaction"</b>) of the Commodity (as defined below)
            to
            <b>{{ Request.PurchaserName }}</b>
            on the trade date specified below the
            <b> {{ DateFromat(Request.ApplicationDate, true) }}</b
            >.

            <br />
            <br />
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: -15px">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Transaction Ref. No.:
          </div>
          <div class="col-xs-7">{{ Request.RefNo }}</div>
        </div>
      </div>
      <div class="row" style="margin-top: -15px">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Commodity:</div>
          <div class="col-xs-7">{{ Request.CommodityName }}</div>
        </div>
      </div>
      <div class="row" style="margin-top: -15px">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Commodity Description:
          </div>
          <div class="col-xs-7">99.95% pt - 'Good Delivery'</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Quantity:</div>
          <div class="col-xs-7">
            {{ Request.StringQuantity }} {{ Request.UnitName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Trade Date:</div>
          <div class="col-xs-7">
            {{ DateFromat(Request.ApplicationDate, true) }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Value Date:</div>
          <div class="col-xs-7">
            {{ DateFromat(Request.ValueDate, true) }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Reference:</div>
          <div class="col-xs-7">
            {{ Request.RefNo }}
          </div>
        </div>
      </div>

      <br />
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <p>
              We hereby instruct you to deliver the Commodity held to our order
              and which forms the subject of the
              <b>Sale Transaction</b>
              to the Purchaser for value on the Value Date by delivery of the
              Commodity to the Purchaser's metal account with you.
            </p>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <br />For and on behalf of
            <br />
            <b>{{ Request.BankName }}</b>
            <br />
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <p style="text-align: center; font-size: 10px; margin-bottom: -15px">
        <em style="font-size: 16px"
          >This is a computer generated document, issued by a secure platform
          and as such, does not require a signature.</em
        >
      </p>
      <hr style="border: 1px solid #b35900" />
      <p style="font-size: 16px; text-align: center; margin-top: -30px">
        <br />Riyadh, Kingdom of Saudi Arabia, www.alinmacapital.com
      </p>
    </div>
  </div>
</template>

<style scoped>
* {
  font-size: 18px;
}
</style>

  <script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
      AggrementDate: "GETAGGREMENTDATE",
      BankLogo: "GETBANKLOGO",
    }),
  },
};
</script>
<style scopped>
tr td {
  border: 0;
}
.Details > tr > td:nth-child(odd) {
  width: 26%;
}
</style>
